import { IconButton, Tooltip } from "@mui/material";

const CustomEditIcon = ({ ...props }) => {
  const color = props?.color || "#1976d2";
  const size = props?.size || "22px";
  const fileSrc = "/public/icon/action-edit.svg";

  return (
    <Tooltip title={props?.label || "Edit"} placement="left" arrow>
      <IconButton {...props}>
        <div
          style={{
            width: size,
            height: size,
            // marginLeft: "10px",
            display: "inline-block",
            verticalAlign: "middle",
            backgroundColor: color,
            maskImage: "url(" + fileSrc + ")",
            maskSize: "contain",
            WebkitMaskImage: "url(" + fileSrc + ")",
            WebkitMaskSize: "contain",
            WebkitMaskRepeat: "no-repeat",
            maskRepeat: "no-repeat",
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default CustomEditIcon;
